import { render, staticRenderFns } from "./InquiryCategorySearch.vue?vue&type=template&id=c89b6b7c&scoped=true"
import script from "./InquiryCategorySearch.vue?vue&type=script&lang=js"
export * from "./InquiryCategorySearch.vue?vue&type=script&lang=js"
import style0 from "./InquiryCategorySearch.vue?vue&type=style&index=0&id=c89b6b7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c89b6b7c",
  null
  
)

export default component.exports